// ═══════════════════════════════════════════════════════════════════════════════
// API CONFIG — single source of truth for the backend URL
//
// Previously this URL was hardcoded in 6 different files (a YouWare artifact:
// each new backend call was pasted with its own copy of the URL). Consolidating
// it here means cutting over to the new Cloudflare Worker is a one-line change
// (or, better, a VITE_BACKEND_URL environment variable set in Cloudflare Pages —
// no code change needed at all).
// ═══════════════════════════════════════════════════════════════════════════════

export const BACKEND_URL: string =
  (import.meta.env.VITE_BACKEND_URL as string | undefined) ||
  'https://dbt81ht2gysyo1mybr20.youbase.cloud';
